import { render, staticRenderFns } from "./PontoCadastro.vue?vue&type=template&id=3429aad2&"
import script from "./PontoCadastro.vue?vue&type=script&lang=js&"
export * from "./PontoCadastro.vue?vue&type=script&lang=js&"
import style0 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=0&lang=css&"
import style1 from "./PontoCadastro.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports